import LogIcon from '@material-ui/icons/PlaylistPlay';
import LogList from './logList.js';

export default {
    icon: LogIcon,
    list: LogList,
};